export default [
  {
    path: '/emtyaz/registration',
    name: 'emtyaz_advising_registration',
    component: () => import('@/views/for_student/emtyaz/RegistrationStudent'),
    meta: { pageTitle: 'Emtyaz',navActiveLink:'emtyaz', breadcrumb: [{ text: 'Emtyaz'} , { text: 'Registration', active: true }] },
  },
]